var inventory_api_client = function(
  physical_in_stock_locally_message,
  physical_in_stock_locally_show_dispatch_message_in_cart,
  physical_in_stock_at_warehouse_message,
  physical_in_stock_at_warehouse_show_dispatch_message_in_cart,
  message_colour,
  shopify_frontend_endpoint_url,
  nonce,
  hmac_digest,
  product_selected_or_first_available_variant_id,
  product_form_id
){
  console.log("running inventory_api_client");
  var callback_url = null;// this may be set to a server for the sending of notification of emails to customers once their downloads are watermarked and ready for download.
  
  // in order to use test emails, authentication must be turned off in shopify_frontend_endpoint.php
  // the liquid variable was not being assigned on some browsers to returns of the function called so it is now added explicitly to all functions.
  
  
  function checkIfInLocalStock() {
    return $.ajax({
    type: "GET",
    url: shopify_frontend_endpoint_url,
    dataType: 'json',
    data: {functionname: 'checkIfInLocalStock', arguments: [product_selected_or_first_available_variant_id], hmacdigest: hmac_digest, nonce: nonce},
    });
   }	
  ///
  
  
  function displayShippingEstimate(obj, textstatus) {
    console.log("displaying shipping estimate now");
    console.log(obj);
    //console.log(textstatus);
    document.getElementById("mmlink_dispatch_estimate").innerHTML = '';                                                     
    if( !('error' in obj) ) {
      var response = obj.result;
      //console.log("response: ");
      //console.log(response);
      var form_element = '';

      if (response) {
        console.log("in local stock");
        if (physical_in_stock_locally_show_dispatch_message_in_cart) {
          form_element = '\
            <input\
              id="mmlink_dispatch_note"\
              name="properties[Lieferbar]"\
              value="' + physical_in_stock_locally_message + '"\
              type="text"\
              form="' + product_form_id + '"\
              style="display: none"\
            >\
          ';
        }
        document.getElementById("mmlink_dispatch_estimate").innerHTML = '\
          <p>\
            <strong>\
              <span style="color: '+ message_colour + '; ">\
                ' + physical_in_stock_locally_message + '\
              </span>\
            </strong>\
            ' + form_element + '\
          </p>';                                                                                                                                                                  
      } else {
        console.log("not in local stock");
        if (physical_in_stock_at_warehouse_show_dispatch_message_in_cart) {
          form_element = '\
            <input\
              id="mmlink_dispatch_note"\
              name="properties[Lieferbar]"\
              value="' + physical_in_stock_at_warehouse_message + '"\
              type="text"\
              form="' + product_form_id + '"\
              style="display: none"\
            >\
          ';
        }
        document.getElementById("mmlink_dispatch_estimate").innerHTML = '\
          <p>\
            <strong>\
              <span style="color: '+ message_colour + '; ">\
                ' + physical_in_stock_at_warehouse_message + '\
              </span>\
            </strong>\
            ' + form_element + '\
          </p>';
      }                                                      
    } else {
      var response = obj.error;    
      console.log(response);
    }
  }

  function log_error(obj, textstatus) {
    console.log("ERROR in json response: ");
    console.log("object:");
    console.log(obj);
    console.log("textstatus:");
    console.log(textstatus);
    if( !('error' in obj) ) {
      var response = obj.result;
      console.log("obj.result:");
      console.log(obj.result);
    }
    else {
      var response = obj.error;
      console.log("obj.error:");
      console.log(obj.error);
    }
  }

  //call ajax immediately on page load
  checkIfInLocalStock().done(displayShippingEstimate).fail(log_error); 
}
